
const NONE_OF_THE_ABOVE_PROMPT = 'None of the above';

const EXCLUSIVE_MULTI_SELECT_PROMPTS = [
  NONE_OF_THE_ABOVE_PROMPT,
];

export const ApplyExclusiveMultiSelectOption = (
  resource,
  multiSelectFieldName,
  exclusivePrompts = EXCLUSIVE_MULTI_SELECT_PROMPTS,
) => {
  const exclusiveOpts = resource.meta().field(multiSelectFieldName).options().list()
    .filter((item) => exclusivePrompts.indexOf(item.attr('prompt')) > -1);

  for (const exclusiveOpt of exclusiveOpts) {
    const exclusiveOptID = exclusiveOpt.id();

    const exclusiveOptIdx = resource.attr(multiSelectFieldName).indexOf(exclusiveOptID);
    // If the exclusive option is selected while some other options are already chosen, we should clear everything but the exclusive option
    if (exclusiveOptIdx > 0) {
      resource.attr(multiSelectFieldName, [exclusiveOptID]);
    }

    // If the exclusive option was selected and another option has been chosen, drop the exclusive option from the choices
    if (exclusiveOptIdx === 0 && resource.attr(multiSelectFieldName).length > 1) {
      resource.attr(
        multiSelectFieldName,
        resource.attr(multiSelectFieldName).filter((item) => item !== exclusiveOptID),
      );
    }
  }
};
